import * as React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { ApplicationState } from "../../store";
import * as AccessControlGroupsState from "../../store/AccessControlGroups";
import { AccessControlGroupResponse } from "../../api/ApiClient";
import SelectAccessControlGroup from "../shared/SelectAccessControlGroup";
import RegisterAccessControlGroup, {
  RegisterAccessControlGroupParams,
} from "../AccessControlGroups/Register";

import Modal from "../shared/Modal";

import "./adminSites.css";
import { confirmPrompt } from "../../helpers";
import { useState, useEffect } from "react";
import Button from "@mui/material/Button";

type ModalType = "accessControlGroup" | null;

const AdminAccessControlGroups: React.FC = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const accessControlGroups = useSelector(
    (state: ApplicationState) => state.accessControlGroups,
  );

  const [registerParams, setRegisterParams] =
    useState<RegisterAccessControlGroupParams | null>(null);
  const [showingModal, setShowingModal] = useState<ModalType>(null);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const registerParamsStr = searchParams.get("registerParams");
    const parsedRegisterParams = registerParamsStr
      ? JSON.parse(registerParamsStr)
      : null;

    if (parsedRegisterParams) {
      setRegisterParams(parsedRegisterParams);
      showAddAccessControlGroupModal();
    }
  }, [location.search]);

  const showAddAccessControlGroupModal = () => {
    setShowingModal("accessControlGroup");
  };

  const closeModal = () => {
    setShowingModal(null);
  };

  const onRegistered = async () => {
    closeModal();
    setRegisterParams(null);
    (dispatch as any)(
      AccessControlGroupsState.actionCreators.requestAccessControlGroups(),
    );
  };

  const renderRegisterAccessControlGroup = () => {
    return (
      <RegisterAccessControlGroup
        onRegistered={onRegistered}
        //@ts-ignore
        initialValues={registerParams}
      />
    );
  };

  const deleteAccessControlGroup = (
    accessControlGroup: AccessControlGroupResponse,
  ) => {
    confirmPrompt({
      promptMessage:
        "Are you sure you want to delete this access control group?",
      onConfirm: async () => {
        try {
          await (dispatch as any)(
            AccessControlGroupsState.actionCreators.deleteAccessControlGroup({
              id: accessControlGroup.id || "",
            }),
          );
          await (dispatch as any)(
            AccessControlGroupsState.actionCreators.requestAccessControlGroups(),
          );
        } catch (e) {
          alert("Error deleting group: " + JSON.stringify(e));
        }
      },
    });
  };

  const renderAccessControlGroupButton = (
    accessControlGroup: AccessControlGroupResponse,
  ) => {
    return (
      <div style={{ display: "flex", gap: 8 }}>
        <Link
          className={`btn btn-sm btn-default`}
          to={`/admin/accessControlGroups/${accessControlGroup.id}`}
        >
          Details
        </Link>
        <Button
          type="button"
          variant="contained"
          color="error"
          onClick={() => deleteAccessControlGroup(accessControlGroup)}
        >
          Delete
        </Button>
      </div>
    );
  };

  const renderAccessControlGroupsTable = () => {
    return (
      <div>
        <p />
        &nbsp;
        <p />
        {
          //@ts-ignore
          <SelectAccessControlGroup
            pageSize={accessControlGroups.pageSize}
            renderButton={renderAccessControlGroupButton}
          />
        }
        <hr />
      </div>
    );
  };
  return (
    <div>
      <br />
      <Button
        type="button"
        variant="contained"
        onClick={showAddAccessControlGroupModal}
      >
        Add AccessControlGroup
      </Button>
      <div>{renderAccessControlGroupsTable()}</div>
      <div>{renderAccessControlGroupsTable()}</div>

      <Modal
        show={!!showingModal}
        onHide={closeModal}
        aria-labelledby="ModalHeader"
        dialogClassName="custom-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title id="ModalHeader">
            {showingModal === "accessControlGroup"
              ? "Add AccessControlGroup"
              : "?"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {showingModal === "accessControlGroup"
            ? renderRegisterAccessControlGroup()
            : null}
        </Modal.Body>
        <Modal.Footer>
          <Modal.Dismiss className="btn btn-default">Close</Modal.Dismiss>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AdminAccessControlGroups;
